import StructuredData from 'components/StructuredData';
import { getYear } from 'date-fns';
import { getUTCDate } from 'lib/Utilities';

interface WebPageStructuredDataProps {
  title?: string;
  description?: string;
  path: string;
  metaPrefix?: string;
}
const WebPageStructuredData = ({
  path,
  description,
  title,
}: WebPageStructuredDataProps): JSX.Element => {
  const url = `https://www.autolist.com${path}`;

  const data = {
    '@type': 'WebPage',
    name: title,
    url,
    description,
    copyrightYear: getYear(getUTCDate()),
    isFamilyFriendly: 'True',
    publisher: {
      '@type': 'Thing',
      name: 'Autolist',
    },
    copyrightHolder: {
      '@type': 'Thing',
      name: 'Autolist',
    },
  };

  return <StructuredData data={data} />;
};

export default WebPageStructuredData;
